import { Navigate, Route, Routes } from 'react-router-dom';

import useGutBodyConnections from 'hooks/useGutBodyConnections';
import { usePrefetchChatbotPrompts } from 'services/chatbotPrompts/useChatbotPrompts';
import useFeature from 'services/features/useFeature';
import { ConditionMetricsList as LegacyConditionMetricsList } from './ConditionMetricsList';
import ConditionsEducationalModal from './ConditionsEducationalModal';
import { ConditionsEducationalModalProvider } from './ConditionsEducationalModal/context';
import { ConditionsDetailFlagGate } from './Details/ConditionsDetailFlagGate';
import { ConditionDetailView } from './EmergingResearch/ConditionDetailView';
import { EmergingResearch } from './EmergingResearch/EmergingResearch';
import NewConditionMetricsList from './NewConditionMetricsList';

export const ConditionsRoutes = () => {
  const { isFeatureEnabled: isHAEMEnabled } = useFeature(
    'health_associations_educational_modal',
  );
  const gutBodyConnections = useGutBodyConnections();
  usePrefetchChatbotPrompts('conditions_detail_page');

  return (
    <ConditionsEducationalModalProvider>
      {isHAEMEnabled ? <ConditionsEducationalModal /> : null}
      <Routes>
        <Route path={``} key='conditions' element={<Navigate to='metrics' />} />
        <Route
          path={`metrics`}
          key='conditions-metrics'
          element={
            gutBodyConnections ? (
              <NewConditionMetricsList />
            ) : (
              <LegacyConditionMetricsList />
            )
          }
        />
        <Route
          path={`emerging-research`}
          key='conditions-emerging-research'
          element={<EmergingResearch />}
        />
        <Route
          path={`:condition`}
          key='conditions-detail'
          element={<ConditionDetailView />}
        />
        <Route
          path={`metrics/:condition`}
          key='conditions-metrics-detail'
          element={<ConditionsDetailFlagGate />}
        />
      </Routes>
    </ConditionsEducationalModalProvider>
  );
};
